export default __webpack_public_path__ + "static/media/booth_3_happyfresh.65b47cbc.png";